import {Component, Input, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import * as Highcharts from "highcharts/highstock";
import { HighchartsChartComponent, providePartialHighcharts } from "highcharts-angular";

@Component({
    selector: 'app-area-chart',
    templateUrl: './area-chart.component.html',
    styleUrls: ['./area-chart.component.scss'],
    imports: [HighchartsChartComponent],
    providers: [
        providePartialHighcharts({
            modules: () => [
                import('highcharts/esm/modules/series-label'),
            ]
        })
    ],
    standalone: true,
})
export class AreaChartComponent implements OnChanges, OnInit {
    @Input() chartSeries: any[];
    @Input() chartColors: string[];
    @Input() minVolatility: any;
    @Input() maxVolatility: any;
    @Input() volatilityLine: any;
    @Input() volatilityLineText: string;
    @Input() sliderVolatility: any;

    Highcharts: typeof Highcharts = Highcharts;
    chartConstructor = 'chart';
    chartOptions: Highcharts.Options = {};

    ngOnInit() {
        // Initialize chart with empty data
        this.initChart();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sliderVolatility) {
            this.sliderVolatility = changes.sliderVolatility.currentValue;
            this.initChart();
        }
        if (changes.chartSeries) {
            this.chartSeries = changes.chartSeries.currentValue;
            this.initChart();
        }
    }

    initChart() {
        if (!this.chartSeries) {
            return;
        }

        this.chartOptions = {
            chart: {
                height: '750px',
                type: 'area',
                backgroundColor: null,
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            colors: this.chartColors,
            tooltip: {
                formatter: function (this: any) {
                    const points = this.points as any[];
                    points.sort((a, b) => {return (b.y) - (a.y)});
                    return this.points.reduce(function (s, point) {
                            if(point.y > 0){
                                return s + '<br/><span style="color:'+point.color+'">\u25CF</span> ' + point.series.name + ': ' +
                                point.y + '%';
                            }else{
                                return s;
                            }
                        }, '<b>Std.Dev:' + this.x + '%</b>');
                },
                shared: true
            },
            plotOptions: {
                area: {
                    pointStart: this.minVolatility,
                    relativeXValue: false,
                    stacking: 'percent',
                    marker: {
                        enabled: false
                    }
                }
            },
            yAxis: {
                labels: {
                    format: '{value}%'
                },
                title: {
                    text: 'Allocation'
                }
            },
            xAxis: {
                type: 'linear',
                labels: {
                    format: '{value}%'
                },
                title: {
                    text: 'Expected Volatility'
                },
                plotLines: [
                {
                    color: 'darkgray',
                    width: 2,
                    value: this.sliderVolatility,
                    zIndex: 5,
                    label: {
                        text: "<div style='background-color:rgb(71, 71, 181); color: white'> Selected Portfolio </div>",
                        useHTML: true,
                        style: {
                            color: 'white',
                            fontWeight: 'bold',
                        },
                        align: "center",
                        verticalAlign: "middle",
                        rotation: 360
                    }
                }]
            },
            series: this.chartSeries
        };
    }
}
